import {observable} from "mobx";
import packageJson from "../../../../package.json";

export default class AppStore {
	@observable historyPath = '/';
	@observable pageTitle = 'Utah Header Examples';
	@observable versions = null;
	@observable currentVersion = null;

	constructor() {
		this.currentVersion = window.location.href.includes('latest') ? 'latest' : packageJson.version.replace(/\./gi, '_');

		fetch('https://cdn.utah.gov/utah-header/versions.json')
			.then(response => {
				if (!response.ok) {
					throw 'Invalid response';
				}
				return response;
			})
			.then(response => response.json())
			.then(versions => this.versions = versions)
			.catch(console.error);
	}
}
